<template>
  <div class="relative mt-12 lg:mt-24 lg:grid lg:grid-cols-2 lg:gap-8 lg:items-center">
    <div>
      <features-one-title/>
      <features-one-list/>
    </div>
    <features-one-svg/>
  </div>
</template>

<script>
import FeaturesOneTitle from "@/components/features/features-one/FeaturesOneTitle";
import FeaturesOneList from "@/components/features/features-one/FeaturesOneList";
import FeaturesOneSvg from "@/components/features/features-one/FeaturesOneSvg";

export default {
  name: "FeaturesOne",
  components: {
    FeaturesOneTitle,
    FeaturesOneList,
    FeaturesOneSvg
  }
}
</script>

<style scoped>

</style>
